import Icon from '../components/Icon';

const CheckCircleFilled = Icon(
  'check-circle-filled',
  <>
    <path
      fillRule="evenodd"
      d="M12 1.25C6.063 1.25 1.25 6.063 1.25 12S6.063 22.75 12 22.75 22.75 17.937 22.75 12 17.937 1.25 12 1.25m4.471 8.555a.667.667 0 1 0-.943-.943l-4.861 4.862-2.196-2.195a.667.667 0 1 0-.942.942l2.666 2.667c.26.26.683.26.943 0z"
      clipRule="evenodd"
    />
  </>
);

export default CheckCircleFilled;
